import React from 'react';
import { ConnectAppsProvider } from './context';
import { Screen } from 'src/components/screen';
import { ConnectAppsContainer } from './container';

const ConnectAppsScreen = () => {
  return (
    <Screen
      contentContainerStyle={{ flex: 1, height: '100%', paddingBottom: 0 }}>
      <ConnectAppsProvider>
        <ConnectAppsContainer />
      </ConnectAppsProvider>
    </Screen>
  );
};

export { ConnectAppsScreen };
